import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { LogoMark, Logo } from "../../components/Logo";
import { useAuth } from "../../context/AuthContext";
import { formatError } from "../../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="grid min-h-screen lg:grid-cols-2">
      <div className="grain relative hidden flex-col justify-between overflow-hidden bg-teal p-12 text-mist lg:flex">
        <Link to="/" className="relative"><Logo /></Link>
        <LogoMark draw className="relative h-64 w-64 text-sage/60" strokeWidth={2.5} />
        <p className="relative label-caps text-mist/80">Content studio</p>
      </div>
      <div className="flex items-center justify-center bg-paper px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
          <Link to="/" className="mb-12 inline-block text-teal lg:hidden"><Logo /></Link>
          <p className="label-caps text-moss">Admin</p>
          <h1 className="mt-4 font-display text-4xl text-teal">Sign in to edit your site</h1>
          <label className="mt-10 block">
            <span className="label-caps !text-[10px] text-moss">Email</span>
            <input type="email" required data-testid="admin-login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 w-full border-b border-teal/30 bg-transparent py-3 text-teal outline-none focus:border-teal" />
          </label>
          <label className="mt-6 block">
            <span className="label-caps !text-[10px] text-moss">Password</span>
            <input type="password" required data-testid="admin-login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 w-full border-b border-teal/30 bg-transparent py-3 text-teal outline-none focus:border-teal" />
          </label>
          {error && <p data-testid="admin-login-error" className="mt-6 text-sm text-red-700">{error}</p>}
          <button type="submit" disabled={busy} data-testid="admin-login-submit" className="label-caps mt-10 flex w-full items-center justify-center gap-2 rounded-full bg-teal py-4 !text-[11px] text-mist transition-colors hover:bg-teal-ink disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </main>
  );
}
